import { EN, DE } from 'utils/consts';

export const LANGUAGES = [
  { id: EN, label: 'EN' },
  { id: DE, label: 'DE' },
];
